import React from "react";
import ReactIcon from "../images/react_icon.png";
import WordPressIcon from "../images/wordpress_icon.png";
import FlutterIcon from "../images/flutter_icon.png";
import PhpIcon from "../images/php_icon.png";
import LaravelIcon from "../images/Laravel_Logo.png";
import UikiticIcon from "../images/ux_icon.png";
import HmtlIcon from "../images/html_icon.png";
import NextjsIcon from "../images/nextjs_icon.png";
import JsIcon from "../images/js_icon.png";
import NodejsIcon from "../images/nodejs_icon.png";
import PythonIcon from "../images/python_icon.png";
import AngularIcon from "../images/angular_icon.png";
import MongoIcon from "../images/mongo_icon.png";
import ShopifyIcon from "../images/Shopify_icon.png";
import CakephpIcon from "../images/cakephp_icon.png";
import WoocommerceIcon from "../images/woocom_icon.png";
import PytorchIcon from "../images/pytorch_icon.png";
import MachinelearningIcon from "../images/machinelearning_icon.png";
import DeeplearningIcon from "../images/deeplearning_icon.png";
import AiIcon from "../images/ai_icon.png";
import DialogflowIcon from "../images/dialogflow_icon.png";
import KerasIcon from "../images/keras-icon.png";
import TensorflowIcon from "../images/tensorflow_icon.png";
import OpenaiIcon from "../images/openai_icon.png";

// Technology data array
const technologyData = [
  {
    id: 1,
    name: "React",
    icon: ReactIcon,
  },
  {
    id: 2,
    name: "WordPress",
    icon: WordPressIcon,
  },
  {
    id: 3,
    name: "Flutter",
    icon: FlutterIcon,
  },
  {
    id: 4,
    name: "PHP",
    icon: PhpIcon,
  },
  {
    id: 5,
    name: "Laravel",
    icon: LaravelIcon,
  },
  {
    id: 6,
    name: "UI/UX Design",
    icon: UikiticIcon,
  },
  {
    id: 7,
    name: "HTML",
    icon: HmtlIcon,
  },
  {
    id: 8,
    name: "Next.js",
    icon: NextjsIcon,
  },
  {
    id: 9,
    name: "JavaScript",
    icon: JsIcon,
  },
  {
    id: 10,
    name: "Node.js",
    icon: NodejsIcon,
  },
  {
    id: 11,
    name: "Python",
    icon: PythonIcon,
  },
  {
    id: 12,
    name: "Angular",
    icon: AngularIcon,
  },
  {
    id: 13,
    name: "MongoDB",
    icon: MongoIcon,
  },
  {
    id: 14,
    name: "Shopify",
    icon: ShopifyIcon,
  },
  {
    id: 15,
    name: "CakePHP",
    icon: CakephpIcon,
  },
  {
    id: 16,
    name: "WooCom",
    icon: WoocommerceIcon,
  },
  {
    id: 17,
    name: "PyTorch",
    icon: PytorchIcon,
  },
  {
    id: 18,
    name: "Machine Learning",
    icon: MachinelearningIcon,
  },
  {
    id: 19,
    name: "Deep Learning",
    icon: DeeplearningIcon,
  },
  {
    id: 20,
    name: "Generative AI",
    icon: AiIcon,
  },
  {
    id: 21,
    name: "Dialogflow",
    icon: DialogflowIcon,
  },
  {
    id: 22,
    name: "Keras",
    icon: KerasIcon,
  },
  {
    id: 23,
    name: "TensorFlow",
    icon: TensorflowIcon,
  },
  {
    id: 24,
    name: "Open AI",
    icon: OpenaiIcon,
  },
];

const Technology = () => {
  return (
    <section className="planning-section technology-section">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-8 mb-4 mb-lg-0 text-center">
            <span className="about-label">Technology</span>
            <h2 className="title">Our Technology</h2>

            <p className="sub-title text-black">
              At Hope Web Solutions, we lead the way in delivering advanced AI
              and Machine Learning solutions...
            </p>
          </div>
        </div>

        <div className="technology-grid">
          {technologyData.map((tech) => (
            <div key={tech.id} className="tech-card">
              <span className="svg-img">
                <img src={tech.icon} alt={tech.name} />
              </span>
              <span>{tech.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Technology;
